
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6519a780!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EmbeddedModuleComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EmbeddedModuleComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6519a780!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EmbeddedModuleComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/EmbeddedModuleComponent.vue
// module id = 126
// module chunks = 2